import { SkillCodes } from "../../manager/components/skill-codes/SkillCodes";

/**
 * @param data  The skill codes data.
 * @param includedYears  The years to include in the search.
 * @returns All included categories for the included years.
 */
export function getIncludedCategories(
  data: SkillCodes,
  includedYears: string[]
) {
  const categories = data.years_order
    .filter((year) => includedYears.includes(year))
    .flatMap((year) => data.years[year].categories);
  return Object.entries(data.categories)
    .filter(([key, value]) => categories.includes(key))
    .map(([key, value]) => value);
}

export const wordToNumber: Record<string, string> = {
  zero: "0",
  one: "1",
  two: "2",
  three: "3",
  four: "4",
  five: "5",
  six: "6",
  seven: "7",
  eight: "8",
  nine: "9",
  ten: "10",
};

export const charPrefixOrSuffixExceptions: Record<string, boolean> = {
  "f'": true,
  "f''": true,
};

export const charWithinStrExceptions: Record<string, string> = {
  "l'hopital": "lhopital",
};

export const specialCharacterReplacements: Record<string, string> = {
  "%": "percent",
};

export const SEPARATOR = /[\s/]+/;

export const whitelistStopWords = ["least", "like", "likely"];

export const stopWords = [
  "a",
  "able",
  "about",
  "across",
  "after",
  "all",
  "almost",
  "also",
  "am",
  "among",
  "an",
  "and",
  "any",
  "are",
  "as",
  "at",
  "be",
  "because",
  "been",
  "but",
  "by",
  "can",
  "cannot",
  "could",
  "dear",
  "did",
  "do",
  "does",
  "either",
  "else",
  "ever",
  "every",
  "for",
  "from",
  "get",
  "got",
  "had",
  "has",
  "have",
  "he",
  "her",
  "hers",
  "him",
  "his",
  "how",
  "however",
  "i",
  "if",
  "in",
  "into",
  "is",
  "it",
  "its",
  "just",
  "let",
  "may",
  "me",
  "might",
  "most",
  "must",
  "my",
  "neither",
  "no",
  "nor",
  "not",
  "of",
  "off",
  "often",
  "on",
  "only",
  "or",
  "other",
  "our",
  "own",
  "rather",
  "said",
  "say",
  "says",
  "she",
  "should",
  "since",
  "so",
  "some",
  "than",
  "that",
  "the",
  "their",
  "them",
  "then",
  "there",
  "these",
  "they",
  "this",
  "tis",
  "to",
  "too",
  "twas",
  "us",
  "wants",
  "was",
  "we",
  "were",
  "what",
  "when",
  "where",
  "which",
  "while",
  "who",
  "whom",
  "why",
  "will",
  "with",
  "would",
  "yet",
  "you",
  "your",
];
